import React, { useMemo, useState } from 'react';
import { IBusinessLocation } from 'models';
import BusinessLocationCard from 'parent-portal/BusinessLocation/BusinessLocationCard';
import AddBusinessLocationForm from 'parent-portal/BusinessLocation/AddBusinessLocationForm';
import { Caption, EmptyText, Modal, PillButton, Row, SearchInput, Stack } from 'library/ui';
import { styled } from '@mui/material';
import { IBusinessFaqQuestions } from 'parent-portal/home/Models/DashboardData';
import { useUserContext } from 'UserContext';

export default function CenterLocations({
    businessLocations,
    refreshBusinessLocations,
    faqQuestions,
}: {
    businessLocations: IBusinessLocation[];
    refreshBusinessLocations: () => void;
    faqQuestions: IBusinessFaqQuestions[];
}) {
    const { user } = useUserContext();
    const [addBusinessLocation, setAddBusinessLocation] = useState(false);
    const [search, setSearch] = useState('');

    const filtered = useMemo(
        () => businessLocations.filter((loc) => loc.name.toLowerCase().includes(search.trim().toLowerCase())),
        [businessLocations, search],
    );

    const canAdd = user?.role === 'BUSINESS';

    return (
        <Stack gap="md">
            {(businessLocations.length > 1 || canAdd) && (
                <Row justify="between" align="center" gap="md">
                    {businessLocations.length > 1 ? (
                        <SearchWrap>
                            <SearchInput value={search} onChange={setSearch} placeholder="Search centers..." />
                        </SearchWrap>
                    ) : (
                        <span />
                    )}
                    <Row gap="md" align="center">
                        {businessLocations.length > 1 && (
                            <Caption>
                                {filtered.length} of {businessLocations.length} centers
                            </Caption>
                        )}
                        {canAdd && <PillButton onClick={() => setAddBusinessLocation(true)}>Add Location</PillButton>}
                    </Row>
                </Row>
            )}

            {filtered.length === 0 ? (
                <EmptyText>No centers match your search.</EmptyText>
            ) : (
                filtered.map((location) => (
                    <BusinessLocationCard key={location.id} businessLocation={location} faqQuestions={faqQuestions} />
                ))
            )}

            {addBusinessLocation && (
                <Modal onClose={() => setAddBusinessLocation(false)} width={640}>
                    <AddBusinessLocationForm
                        cancel={() => setAddBusinessLocation(false)}
                        complete={() => {
                            refreshBusinessLocations();
                            setAddBusinessLocation(false);
                        }}
                        optionalContact
                    />
                </Modal>
            )}
        </Stack>
    );
}

const SearchWrap = styled('div')({
    width: 360,
    maxWidth: '100%',
});
